import { Controller } from "stimulus";

import { formatSubtotal } from "../../utils/cart";
export default class extends Controller {
  static values = {
    sku: String,
    initialQuantity: Number,
    quantity: Number,
    price: Number,
    maxQuantity: Number,
    priceRange: Boolean,
    perUnitMidPrice: Number,
  };

  static targets = [
    "modal",
    "incrementQuantity",
    "subtotal",
    "submitButton",
    "plusButton",
    "minusButton",
  ];

  connect() {
    this._showModal();
    this._setInitialQuantity();
    this._setInitialSubtotal();
    this._setInitialSubmitButtonState();
  }

  hideModal() {
    this.modalTarget.classList.add("hidden");
  }

  updateQuantity(event) {
    const updatedValue = this.quantityValue + event.params.quantity;

    if (
      (this.initialQuantityValue === 0 && updatedValue <= 1) ||
      updatedValue < 1
    ) {
      this._setMinusButtonDisabledAttribute(true);
    } else {
      this._setMinusButtonDisabledAttribute(false);
    }

    if (updatedValue >= this.maxQuantityValue) {
      this._setPlusButtonDisabledAttribute(true);
    } else {
      this._setPlusButtonDisabledAttribute(false);
    }

    this.quantityValue = updatedValue;

    this._setQuantity(updatedValue);
    this._setSubtotal(updatedValue);
    this._setSubmitButtonState(this.initialQuantityValue, updatedValue);
  }

  submit() {
    this.dispatch("submit", {
      detail: { data: { sku: this.skuValue, quantity: this.quantityValue } },
    });
    this.hideModal();
  }

  _showModal() {
    this.modalTarget.classList.remove("hidden");
  }

  _setInitialQuantity() {
    this._setQuantity(this.quantityValue);
  }

  _setInitialSubtotal() {
    this._setSubtotal(this.quantityValue);
  }

  _setInitialSubmitButtonState() {
    if (
      (this.initialQuantityValue === 0 && this.quantityValue === 1) ||
      this.quantityValue === 0
    ) {
      this._setMinusButtonDisabledAttribute(true);
    } else {
      this._setMinusButtonDisabledAttribute(false);
    }

    if (this.quantityValue >= this.maxQuantityValue) {
      this._setPlusButtonDisabledAttribute(true);
    } else {
      this._setPlusButtonDisabledAttribute(false);
    }

    this._setSubmitButtonState(this.initialQuantityValue, this.quantityValue);
  }

  _setSubmitButtonState(initialQuantity, newQuantity) {
    this._setSubmitButtonText(initialQuantity, newQuantity);
    this._setSubmitButtonDisabledAttribute(initialQuantity, newQuantity);
  }

  _setSubmitButtonDisabledAttribute(initialQuantity, newQuantity) {
    if (initialQuantity === newQuantity) {
      this.submitButtonTarget.setAttribute("disabled", true);
    } else {
      this.submitButtonTarget.removeAttribute("disabled");
    }
  }

  _setPlusButtonDisabledAttribute(disabled) {
    if (disabled) {
      this.plusButtonTarget.setAttribute("disabled", true);
    } else {
      this.plusButtonTarget.removeAttribute("disabled");
    }
  }

  _setMinusButtonDisabledAttribute(disabled) {
    if (disabled) {
      this.minusButtonTarget.setAttribute("disabled", true);
    } else {
      this.minusButtonTarget.removeAttribute("disabled");
    }
  }

  _setSubmitButtonText(initialQuantity, newQuantity) {
    let text = "";

    if (!initialQuantity) {
      text = "Add To Cart";
    } else if (newQuantity === 0) {
      text = "Remove From Cart";
    } else {
      text = "Update Cart";
    }

    this.submitButtonTarget.innerHTML = text;
  }

  _setQuantity(quantity) {
    this.incrementQuantityTarget.innerHTML = quantity;
  }

  _setSubtotal(quantity) {
    this.subtotalTarget.innerHTML = formatSubtotal(
      quantity,
      this.perUnitMidPriceValue,
      this.priceRangeValue,
    );
  }
}
